// extracted by mini-css-extract-plugin
export default {"inputWrapper":"InputBox_inputWrapper__dQUkz","sendButton":"InputBox_sendButton__xQ33z"};